export const primitives = {
  color: {
    blue: {
      50: '#E8F1FD',
      100: '#BBD7FA',
      300: '#7CB7F4',
      400: '#49A3F1',
      500: '#1A73E8',
      600: '#1662C4',
      700: '#1452A3',
      800: '#24406E',
      900: '#1B2B4A',
    },
    slate: { 300: '#C9D3E8', 200: '#DDE3F0', 500: '#344767', 600: '#2C3C58' },
    charcoal: { 500: '#42424A', 700: '#2A2A31', 900: '#191919', 950: '#111111' },
    green: { 100: '#E8F5E9', 500: '#2E7D32', 700: '#1B5E20' },
    orange: { 100: '#FFF3E0', 500: '#B85C00', 700: '#8A4500' },
    red: { 100: '#FDECEA', 500: '#D32F2F', 700: '#B71C1C' },
    neutral: {
      0: '#FFFFFF',
      25: '#F8F9FA',
      50: '#F0F2F5',
      75: '#F5F6F8',
      100: '#EBEFF4',
      200: '#DEE2E6',
      300: '#CED4DA',
      350: '#C3C7D0',
      400: '#ADB5BD',
      500: '#5F6B85',
      650: '#3B4766',
      700: '#2F3A57',
      750: '#26304A',
      800: '#202940',
      900: '#1A2035',
      950: '#E9ECF3',
      1000: '#344767',
    },
  },
  space: {
    0: '0',
    1: '4px',
    2: '8px',
    3: '12px',
    4: '16px',
    5: '20px',
    6: '24px',
    8: '32px',
    10: '40px',
    12: '48px',
  },
  fontSize: { xs: '12px', sm: '14px', md: '16px', lg: '18px', xl: '22px', '2xl': '30px', '3xl': '36px' },
  fontWeight: { regular: '400', medium: '500', semibold: '600', bold: '700' },
  lineHeight: { tight: '1.2', normal: '1.5' },
  radius: { sm: '8px', md: '12px', lg: '16px', xl: '20px', full: '999px' },
  shadow: {
    sm: '0 1px 2px rgba(52, 71, 103, 0.08)',
    md: '0 2px 6px rgba(52, 71, 103, 0.06), 0 8px 24px rgba(52, 71, 103, 0.08)',
    lg: '0 16px 40px rgba(25, 25, 25, 0.22)',
    field: 'inset 0 1px 2px rgba(52, 71, 103, 0.05)',
  },
  motion: { fast: '150ms', slow: '1200ms', easing: 'cubic-bezier(0.2, 0, 0, 1)' },
} as const;

export const breakpoints = { xs: 0, sm: 480, md: 768, lg: 1024, xl: 1280, '2xl': 1536 } as const;

export type Breakpoint = keyof typeof breakpoints;
